import { useRef } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { NavLink, useNavigate } from 'react-router-dom';
import { v4 as uuidv4 } from 'uuid';
import { actions } from '../../../Data/ReduxViewModels/SearchWorksheets';
import { worksheetNavLinks } from '../../../Data/Search';
import { IconClear, IconSearch } from '../../../Lib/Icons';
import { Button, Spinner, TextInput } from '../../Core';
import RecentTests from '../RecentTests';
import SearchNav from '../SearchNav';
import './SimpleSearch.scss';

const searchWorksheetsLimit = 20;
const SimpleSearch = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const searchWorksheets = useSelector((state) => state.searchWorksheets.worksheets);
  const searchingForWorksheets = useSelector((state) => state.searchWorksheets.searching);
  const searchText = useSelector((state) => state.searchWorksheets.search);
  const searchInput = useRef();

  const getSearchResults = (newSearchText) => {
    if (newSearchText === null || newSearchText === '') {
      /* Clear search */
      dispatch(actions.searchClear());
    } else if (newSearchText !== searchText) {
      /* only call search if we have a different search value
      sample id search onchange event gets called more often than it should*/
      dispatch(actions.searchGet({ search: newSearchText, limit: searchWorksheetsLimit, searchId: uuidv4() }));
    }
  };

  const newAdvancedSearch = () => {
    dispatch(
      actions.advancedSearchNewSearch({
        search: searchText,
      })
    );
  };

  const handleKeyDown = (e) => {
    const ENTER_KEYCODE = 13;
    if (e.keyCode === ENTER_KEYCODE && !e.defaultPrevented) {
      e.preventDefault();
      newAdvancedSearch();
      navigate('/search');
    }
  };

  return (
    <div className="SimpleSearch">
      <div className="SimpleSearch-Search">
        <TextInput
          placeholder="Search for Sample ID"
          maxLength="20"
          autoFocus
          onChange={(e) => getSearchResults(e.data.value)}
          onKeyDown={handleKeyDown}
          value={searchText}
          focusRef={searchInput}
        />
        <Button
          className="SimpleSearch-ClearButton"
          subtle
          onClick={() => {
            getSearchResults(null);
            searchInput.current?.focus();
          }}
        >
          <IconClear />
        </Button>
      </div>
      {!!searchText && searchingForWorksheets ? (
        <Spinner large />
      ) : (
        <>
          <div className="SimpleSearch-Items">
            {!searchText && <RecentTests />}
            {!!searchText && searchWorksheets && (
              <SearchNav
                links={worksheetNavLinks(searchWorksheets?.worksheets, searchWorksheets?.search)}
                heading={undefined}
                placeholder={
                  'No matching search results were found from recent items. Advanced search can be used to search all items.'
                }
              />
            )}
          </div>
          <div className="SimpleSearch-AdvancedSearch">
            <NavLink to="/search" className="AdvancedSearch-Item" onClick={newAdvancedSearch}>
              <div className="AdvancedSearch-Icon">
                <IconSearch />
              </div>
              <div className="AdvancedSearch-Text">Advanced Search</div>
            </NavLink>
          </div>
        </>
      )}
    </div>
  );
};

export { SimpleSearch };
export default SimpleSearch;
